import { defineStore } from 'pinia'
import { getTenantInfo } from '@/services'
import { getApiType, setCurrentUser } from '@/context/user'

export const useGlobalDataStore = defineStore('useGlobalDataStore', {
  state: () => {
    return {
      globalData: {},
      routerInfo: {
        applicationCenterIndex: {
          name: 'applicationCenterIndex',
          params: {},
          isActive: false
        },
        applicationCenterDetail: {
          name: 'applicationCenterDetail',
          params: {},
          isActive: false
        },
        Recharge: {
          name: 'Recharge',
          params: {},
          isActive: false
        }
      }
    }
  },
  actions: {
    init() {
      this.globalData = {
        isCy: false,
        isSupportInvoice: false, // 是否支持填写发票信息（零售需要去掉该步骤）
        SupportPayment: [], // 支持的支付方式：返回"1,2" 或者空 就是支付宝微信都是支持， 返回1 就是只支持微信，返回2 就是只支持支付宝
        isSupportWXPay: false, // 是否支持微信支付（仅控制小程序支付方式，pc端写死只支持支付宝）
        isFromSpecialReminderForCloudServiceFees: false, // 是否从后台云服务续费广告活动跳转
        isUseSimpleProcess: false, // 是否使用简化流程
        Code: '',
        ProductType: null, // 商户类型
        TenantId: null,
        TenantCode: '',
        TenantName: null,
        OperatorId: null,
        OperatorName: '',
        Contacts: '',
        Phone: '',
        BranchType: '',
        BranchId: null,
        IsPaid: false // 商户是否购买
      }
    },
    updateRouterInfo(name, params) {
      if (!this.routerInfo[name]) return
      this.routerInfo[name].params = params
      this.routerInfo[name].isActive = true
    },
    async getTenantAndOperInfo() {
      if (!this.globalData.TenantId) {
        const res = await getTenantInfo()
        await res.errorStop({ title: '获取商户信息失败' })
        const {
          SupportPayment,
          ProductType,
          TenantId,
          TenantCode,
          TenantName,
          OperatorId,
          OperatorName,
          OperatorCode,
          BranchType,
          BranchId,
          BranchCode,
          BranchName,
          Contacts,
          Phone,
          IsPaid
        } = res.Data
        this.globalData.SupportPayment = SupportPayment ? SupportPayment.split(',') : ['1', '2']
        this.globalData.isSupportWXPay = this.globalData.SupportPayment.includes('1')
        this.globalData.ProductType = ProductType
        this.globalData.TenantId = TenantId
        this.globalData.TenantCode = TenantCode
        this.globalData.TenantName = TenantName
        this.globalData.OperatorId = OperatorId
        this.globalData.OperatorName = OperatorName || ''
        this.globalData.OperatorCode = OperatorCode || ''
        this.globalData.Contacts = Contacts || ''
        this.globalData.Phone = Phone || ''
        this.globalData.BranchType = BranchType
        this.globalData.BranchId = BranchId || null
        this.globalData.BranchCode = BranchCode || ''
        this.globalData.BranchName = BranchName || ''
        this.globalData.IsPaid = !!IsPaid // 确保为布尔类型
      }
      if (getApiType() == 'cy') {
        this.globalData.isCy = true
        // this.globalData.isSupportInvoice = true
      }
      const { TenantId, TenantCode, TenantName, OperatorId, OperatorName, BranchType, BranchId } = this.globalData
      // 埋点取值用到
      setCurrentUser({
        TenantId,
        TenantCode,
        TenantName,
        OperId: OperatorId,
        OperName: OperatorName,
        BranchType,
        BranchId
      })
      return this.globalData
    }
  }
})
